const selectors = {
  block: '[data-woo-product-detail-gallery]',
  image: '.flex-control-thumbs li',
  quality: '[data-woo-product-detail-gallery] .quantity'
}

function init() {
  const block = document.querySelector(selectors.block);

  if (!block) return;

  block.addEventListener('click', (e) => {
    const images = document.querySelectorAll(selectors.image);

    Array.from(images).map(image => {
      // @ts-ignore
      if (image.contains(e.target)) {
        image.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "center",
        })
      }
    })
  })
}

function initQuantity() {
  const block = document.querySelector(selectors.quality);

  if (!block) return;

  const isHidden = block.querySelector('input[type="hidden"]')

  if (isHidden) return;

  const beforeButton = document.createElement('div')
  beforeButton.innerHTML = '<button class="w-8 h-8 rounded border border-black-200 backdrop-blur-md transition-all hover:bg-surface-black-1000 hover:text-surface-white-1000" type="button" onclick="this.parentNode.parentNode.querySelector(\'[type=number]\').stepDown();">-</button>'
  // @ts-ignore
  block.insertBefore(beforeButton, block.firstChild);

  const afterButton = document.createElement('div')
  afterButton.innerHTML = '<button class="w-8 h-8 rounded border border-black-200 backdrop-blur-md transition-all hover:bg-surface-black-1000 hover:text-surface-white-1000" type="button" onclick="this.parentNode.parentNode.querySelector(\'[type=number]\').stepUp();">+</button>'
  block.appendChild(afterButton)
}

document.addEventListener(
  'DOMContentLoaded',
  async function () {
    init();
    initQuantity()
  },
  {
    once: true,
  }
);
